import { TableColumn } from "element-ui";

/**
 * props:{ title, label, width}
 */
const ColumnsFactory = args => {
  const { children = [] } = args.data.props
  if (children.length > 0) {
    return <TableColumn {...args}>
      {children.map(child => <TableColumn {...{ props: child }} />)}
    </TableColumn>;
  }
  return <TableColumn {...args}></TableColumn>;
};

export default ColumnsFactory;
